var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "span",
        {
          staticClass: "sr-only",
        },
        [
          _vm._v(
            _vm._s(
              _vm.$gettext(
                "Um einen Tag zu erstellen, schließen Sie Ihre Eingabe mit der Eingabetaste ab."
              )
            )
          ),
        ]
      ),
      _vm._v(" "),
      _c("TagsInput", {
        attrs: {
          "add-on-key": [13, ";"],
          "autocomplete-items": _vm.filteredItems,
          maxlength: 1000,
          "save-on-key": [13, ";"],
          separators: [";"],
          tags: _vm.formattedTags,
          placeholder: _vm.$gettext("Tag hinzufügen"),
        },
        on: {
          "tags-changed": _vm.onTagsChanged,
        },
        scopedSlots: _vm._u([
          {
            key: "tag-actions",
            fn: function fn(_ref) {
              var index = _ref.index,
                edit = _ref.edit,
                performDelete = _ref.performDelete
              return [
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: edit,
                      expression: "edit",
                    },
                  ],
                  staticClass: "ti-icon-undo",
                  attrs: {
                    tabindex: "0",
                  },
                  on: {
                    keyup: function keyup($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.performcancelEdit(index)
                    },
                    click: function click($event) {
                      return _vm.performcancelEdit(index)
                    },
                  },
                }),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !edit,
                      expression: "!edit",
                    },
                  ],
                  staticClass: "ti-icon-close",
                  attrs: {
                    tabindex: "0",
                    title: _vm.$gettext("Tag entfernen"),
                  },
                  on: {
                    keyup: function keyup($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return performDelete(index)
                    },
                    click: function click($event) {
                      return performDelete(index)
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tag,
          callback: function callback($$v) {
            _vm.tag = $$v
          },
          expression: "tag",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }